module.exports = __webpack_public_path__ + "img/chevron-down.d6715598.svg";